import React, { useEffect } from "react";
import { Header } from "components/global";
import { LawyerBottomNavbar } from "components/pages/lawyer";
import { useSession } from "next-auth/react";
import PropTypes from "prop-types";
import { FaHome, FaBell, FaBook, FaCalendarAlt } from "react-icons/fa";
import useCallStore from "store/useCallStore";

function LawyerLayout({ children, showMobileHeader = false }) {
  const { data: session } = useSession();
  const setPeerUser = useCallStore(state => state.setPeerUser);

  useEffect(() => {
    if (session?.user) {
      setPeerUser({
        userId: session.user.id,
        userName: session.user.full_name,
        userType: session.user.role,
        avatar: session.user.avatar,
      })
    }
  }, [session, setPeerUser]);

  const full_name = session?.user?.full_name || "";
  const avatar = session?.user?.avatar || "";

  const navItems = [
    { title: "الرئيسية", icon: <FaHome />, href: "/lawyer" },
    { title: "الحجوزات", icon: <FaBook />, href: "/lawyer/bookings?status=upcoming" },
    { title: "الجداول", icon: <FaCalendarAlt />, href: "/lawyer/schedules" },
    { title: "صفحتي", icon: <FaBell />, href: "/profile" },
  ];
  return (
    <div className="pb-20">
      {showMobileHeader && (
        <Header
          title={full_name ? `مرحبا أ, ${full_name}` : "مرحبا بك"}
          image={avatar || "/tqneen/default-user.jpg"}
          isRow
        />
      )}

      <div className="container">
        {children}
      </div>



      <LawyerBottomNavbar navItems={navItems} />
    </div>
  );
}

LawyerLayout.propTypes = {
  children: PropTypes.node.isRequired,
  showMobileHeader: PropTypes.bool,
};

export default LawyerLayout;
